import { ref } from 'vue';

export const currentLanguage = ref('en');

export const changeLanguage = (newLanguage) => {
  currentLanguage.value = newLanguage;
};